module.exports = __webpack_public_path__ + "static/media/LandingPageLogo.9ca5a4fc.svg";